module.exports = __webpack_public_path__ + "img/add-photo-fifth-icon.28ea6dd3.svg";